import * as Sentry from '@sentry/react';
// import { releaseConfig } from '@arc/shared/config/common';
//
import { errorFallbackRender } from './errorFallbackRenderer';
/**
 * Catch errors and render a fallback UI.
 *
 * NOTE: This component was made to be used as the root level error boundary.
 *       In the future it may be used in other places, but the
 *       {@link errorFallbackRender} will need to be modified.
 */
export function HubErrorBoundary({
  children
}) {
  return <Sentry.ErrorBoundary fallback={errorFallbackRender} onError={err => {
    if (err instanceof Error && err.name === 'ChunkLoadError') {
      window.location.reload();
    }
  }}>
			{children}
		</Sentry.ErrorBoundary>;
}